import { Modal, Button, Space, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { formatDollars, formatPercentage } from './budgetCalculatorModel'

const { Title, Text } = Typography

type CongratulationsModalProps = {
  open: boolean
  onClose: () => void
  salesGoal: number
  profitMargin: number
  requiredSales: number
}

export const CongratulationsModal = ({
  open,
  onClose,
  salesGoal,
  profitMargin,
  requiredSales
}: CongratulationsModalProps) => {
  const needsHigherGoal = requiredSales > salesGoal
  const totalCosts = requiredSales * (1 - profitMargin)

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      width={700}
    >
      <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center', padding: '24px 0' }}>
        {/* Success Icon */}
        <div style={{
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          backgroundColor: '#52c41a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto'
        }}>
          <FontAwesomeIcon icon={faCheck} style={{ fontSize: '48px', color: 'white' }} />
        </div>

        {/* Title */}
        <Title level={2} style={{ margin: 0 }}>
          {needsHigherGoal ? "We've Updated Your Sales Goal!" : "Great Job Planning Ahead!"}
        </Title>

        {/* Message */}
        {needsHigherGoal ? (
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Text style={{ fontSize: '16px', color: '#666' }}>
              You set your goal at <strong>{formatDollars(salesGoal)}</strong>, but to reach a <strong>{formatPercentage(profitMargin)}</strong> profit margin,
              you'll need <strong>{formatDollars(requiredSales)}</strong> in sales based on your costs.
            </Text>
            <Text style={{ fontSize: '16px', color: '#666' }}>
              Next, you'll see your budget worksheet, where you can fine-tune your expenses and adjust your sales goal further.
            </Text>
          </Space>
        ) : (
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Text style={{ fontSize: '16px', color: '#666' }}>
              According to the information you entered, your business has <strong>{formatDollars(totalCosts)}</strong> in operating costs,
              which means you would need to hit <strong>{formatDollars(requiredSales)}</strong> in sales in order to achieve a <strong>{formatPercentage(profitMargin)}</strong> profit margin.
            </Text>
            <Text style={{ fontSize: '16px', color: '#666' }}>
              Next, you'll see your budget worksheet, where you can fine-tune your expenses and adjust your sales goal further.
            </Text>
          </Space>
        )}

        {/* Button */}
        <Button
          type="primary"
          size="large"
          onClick={onClose}
          style={{
            backgroundColor: '#ff6b4a',
            borderColor: '#ff6b4a',
            height: '56px',
            fontSize: '18px',
            width: '100%',
            marginTop: '16px'
          }}
        >
          View Budget Worksheet
        </Button>
      </Space>
    </Modal>
  )
}
